// @ts-nocheck
(function () {
  var GA_TO_INTERNAL_EVENT_MAP = {
    ga_pwst_login_page_viewed: "internal_pwst_login_page_viewed",
    ga_pwst_mobile_number_clicked: "internal_pwst_mobile_number_clicked",
    ga_pwst_get_otp_clicked: "internal_pwst_get_otp_clicked",
    ga_pwst_login_enter_name_clicked: "internal_pwst_login_enter_name_clicked",
    ga_pwst_search_initiated: "internal_pwst_search_initiated",
    ga_pwst_cohort_change_clicked: "internal_pwst_cohort_change_clicked",
    ga_pwst_cohort_change_submitted: "internal_pwst_cohort_change_submitted",
    ga_pwst_banner_clicked: "internal_pwst_banner_clicked",
    ga_pwst_pincode_serviceability_checked: "internal_pwst_pincode_serviceability_checked",
    ga_pwst_store_faq_viewed: "internal_pwst_store_faq_viewed",
    ga_pwst_add_to_bag: "internal_pwst_add_to_bag",
    ga_pwst_remove_from_bag: "internal_pwst_remove_from_bag",
    ga_pwst_filter_applied: "internal_pwst_filter_applied",
    ga_pwst_product_listing_page_viewed: "internal_pwst_product_listing_page_viewed",
    ga_pwst_sort_by_applied: "internal_pwst_sort_by_applied",
    ga_pwst_product_items_viewed: "internal_pwst_product_items_viewed",
    ga_pwst_track_order_clicked: "internal_pwst_track_order_clicked",
    ga_pwst_my_order_item_details_clicked: "internal_pwst_my_order_item_details_clicked",
    ga_pwst_store_start: "internal_pwst_store_start",
    ga_pwst_login_auth: "internal_pwst_login_auth",
    ga_pwst_logout: "internal_pwst_logout",
    ga_pwst_search_submitted: "internal_pwst_search_submitted",
    ga_pwst_search_result_page_viewed: "internal_pwst_search_result_page_viewed",
    ga_pwst_page_viewed: "internal_pwst_page_viewed",
    ga_pwst_product_description_viewed: "internal_pwst_product_description_viewed",
    ga_pwst_product_item_clicked: "internal_pwst_product_item_clicked",
    ga_pwst_cart_page_viewed: "internal_pwst_cart_page_viewed",
    ga_pwst_coupon_actions_taken: "internal_pwst_coupon_actions_taken",
    ga_pwst_coupons_view_all_cta_clicked: "internal_pwst_coupons_view_all_cta_clicked",
    ga_pwst_coupons_strip_viewed: "internal_pwst_coupons_strip_viewed",
    ga_pwst_coupons_strip_clicked: "internal_pwst_coupons_strip_clicked",
    ga_pwst_remove_filter: "internal_pwst_remove_filter",
    ga_pwst_cancel_order_clicked: "internal_pwst_cancel_order_clicked",
    ga_pwst_banner_hover_clicked: "internal_pwst_banner_hover_clicked",
    ga_pwst_product_preview_viewed: "internal_pwst_product_preview_viewed",
    ga_pwst_bottom_navigation_clicked: "internal_pwst_bottom_navigation_clicked",
    ga_pwst_write_product_review_clicked: "internal_pwst_write_product_review_clicked",
    ga_pwst_write_product_review_submitted: "internal_pwst_write_product_review_submitted",
    ga_pwst_product_notify_me_submitted: "internal_pwst_product_notify_me_submitted",
    ga_pwst_sale_notify_me_submitted: "internal_pwst_sale_notify_me_submitted",
    ga_pwst_sale_flash_banner_click: "internal_pwst_sale_flash_banner_click",
    ga_pwst_share_clicked: "internal_pwst_share_clicked",
    ga_pwst_browse_by_exam_clicked: "internal_pwst_browse_by_exam_clicked",
    ga_pwst_browse_by_age_navigation_clicked: "internal_pwst_browse_by_age_navigation_clicked",
    ga_pwst_tabbed_product_carousel_viewed: "internal_pwst_tabbed_product_carousel_viewed",
    ga_pwst_tabbed_product_carousel_item_clicked: "internal_pwst_tabbed_product_carousel_item_clicked",
    ga_pwst_view_all_cta_clicked: "internal_pwst_view_all_cta_clicked",
    ga_pwst_loading_time_sec: "internal_pwst_loading_time_sec",
    ga_pwst_product_media_loaded: "internal_pwst_product_media_loaded",
    ga_pwst_product_card_loaded: "internal_pwst_product_card_loaded",
    ga_pwst_buy_now_click: "internal_pwst_buy_now_click",
    ga_pwst_prep_online_ingress_viewed: "internal_pwst_prep_online_ingress_viewed",
    ga_pwst_prep_online_ingress_clicked: "internal_pwst_prep_online_ingress_clicked",
    ga_pwst_external_order_page_ingress: "internal_pwst_external_order_page_ingress",
  };

  var seenMappedEvents = typeof WeakSet !== "undefined" ? new WeakSet() : null;
  var pendingFlushTimer = null;
  var FORCE_FLUSH_DELAY_MS = 250;
  var GEO_READY_WAIT_MS = 4500;

  /** App slug for headers (not the per-user batch `name` in SDK v1.1.0) */
  var PW_STORE_APP_SLUG = "pw_store";
  /** Theme release; keep in sync with custom headers x-app-version */
  var PW_STORE_APP_VERSION = "1.3.0";
  const STAGE_ANALYTICS_BASE_URL = "https://analytics-api-stage.penpencil.co";
  const PROD_ANALYTICS_BASE_URL = "https://analytics-api.penpencil.co";

  function resolveAnalyticsBaseUrl() {
    const configured = window.__PW_ANALYTICS_BASE_URL__;
    if (configured) return String(configured).replace(/\/$/, "");

    const shopUrl = String(window.__PW_SHOP_URL__ || "").toLowerCase();
    const host = String((window.location && window.location.hostname) || "").toLowerCase();
    const isStage =
      shopUrl.includes("marketplace-stage") ||
      host.includes("marketplace-stage") ||
      (host.includes("stage") && host.includes("physicswallah"));

    return isStage ? STAGE_ANALYTICS_BASE_URL : PROD_ANALYTICS_BASE_URL;
  }

  /** Shopify `customer.name` from `__CUSTOMER_DATA__.customer_name`; null when logged out */
  function resolveCustomerNameForTracker() {
    try {
      var data = window.__CUSTOMER_DATA__;
      if (!data || data.customer_name == null) return null;
      var s = String(data.customer_name).trim();
      return s.length ? s : null;
    } catch (e) {
      return null;
    }
  }

  function resolvePwUserIdFromContext() {
    try {
      var data = window.__CUSTOMER_DATA__;
      if (!data || data.pw_user_id == null) return null;
      var s = String(data.pw_user_id).trim();
      return s.length ? s : null;
    } catch (e) {
      return null;
    }
  }

  function getSafeUserId(currentUserId) {
    if (currentUserId != null && String(currentUserId).trim() !== "") {
      return String(currentUserId).trim();
    }
    var fromContext = resolvePwUserIdFromContext();
    if (fromContext) return fromContext;
    return "anonymous";
  }

  function getAuthTokenFromSessionStorage() {
    try {
      // Token is commonly stored in localStorage; fall back to sessionStorage
      var raw =
        (window.localStorage ? window.localStorage.getItem("STORE_TOKEN_CONTEXT") : null) ||
        (window.sessionStorage ? window.sessionStorage.getItem("STORE_TOKEN_CONTEXT") : null);
      if (!raw) return null;
      var ctx = JSON.parse(raw);
      if (ctx && ctx.token) return String(ctx.token);
      return null;
    } catch (e) {
      return null;
    }
  }

  function scheduleFastFlush() {
    if (pendingFlushTimer) return;
    pendingFlushTimer = window.setTimeout(function () {
      pendingFlushTimer = null;
      if (window.PWLightTrackerJS && typeof window.PWLightTrackerJS.flush === "function") {
        window.PWLightTrackerJS.flush();
      }
    }, FORCE_FLUSH_DELAY_MS);
  }

  function isAlreadyMappedEvent(eventData) {
    if (!eventData || typeof eventData !== "object") return true;

    if (seenMappedEvents) {
      if (seenMappedEvents.has(eventData)) return true;
      seenMappedEvents.add(eventData);
      return false;
    }

    if (eventData.__pwtrackerMapped === true) return true;
    try {
      eventData.__pwtrackerMapped = true;
    } catch (e) {}
    return false;
  }

  function generateInternalEventId() {
    if (
      window.PWTrackerRequiredAttrs &&
      typeof window.PWTrackerRequiredAttrs.generateEventId === "function"
    ) {
      return window.PWTrackerRequiredAttrs.generateEventId();
    }
    try {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
    } catch (e) {}
    return String(Date.now()) + "_" + String(Math.floor(Math.random() * 1000000));
  }

  function enrichGaPwstEventIdentity(eventData) {
    if (!eventData || typeof eventData !== "object" || Array.isArray(eventData)) return eventData;
    const eventName = eventData.event;
    if (!eventName || String(eventName).indexOf("ga_pwst_") !== 0) return eventData;

    if (typeof window.enrichGaPwstEventIdentity === "function" && window.enrichGaPwstEventIdentity !== enrichGaPwstEventIdentity) {
      return window.enrichGaPwstEventIdentity(eventData);
    }

    if (
      window.PWTrackerRequiredAttrs &&
      typeof window.PWTrackerRequiredAttrs.getTrackingFieldsForEvent === "function"
    ) {
      const fields = window.PWTrackerRequiredAttrs.getTrackingFieldsForEvent();
      if (eventData.anonymous_id == null || eventData.anonymous_id === "") {
        eventData.anonymous_id = fields.anonymous_id;
      }
      if (eventData.session_id == null || eventData.session_id === "") {
        eventData.session_id = fields.session_id;
      }
      if (eventData.event_id == null || eventData.event_id === "") {
        eventData.event_id = fields.event_id;
      }
    }

    const fromApp = typeof window.getFromAppFlag === "function" ? window.getFromAppFlag() : false;
    eventData.from_app = fromApp;
    eventData.is_in_webview = fromApp;
    if (typeof window.resolveGtmPlatform === "function") {
      eventData.platform = window.resolveGtmPlatform();
    }

    return eventData;
  }

  function coerceWidgetPositionNumber(value) {
    if (value == null || value === "") return null;
    var n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function normalizeWidgetPositionAttributes(data) {
    if (!data || typeof data !== "object" || Array.isArray(data)) return data;
    if (typeof window.normalizeWidgetPositionAttributes === "function") {
      return window.normalizeWidgetPositionAttributes(data);
    }
    var result = Object.assign({}, data);
    if (result.product_position_inside_widget == null || result.product_position_inside_widget === "") {
      if (result.position_inside_widget != null && result.position_inside_widget !== "") {
        result.product_position_inside_widget = result.position_inside_widget;
      }
    }
    delete result.position_inside_widget;
    if (result.page_widget_position == null || result.page_widget_position === "") {
      if (result.widget_position != null && result.widget_position !== "") {
        result.page_widget_position = result.widget_position;
      }
    }
    delete result.widget_position;
    if (result.product_position_inside_widget != null && result.product_position_inside_widget !== "") {
      result.product_position_inside_widget = coerceWidgetPositionNumber(result.product_position_inside_widget);
    }
    if (result.page_widget_position != null && result.page_widget_position !== "") {
      result.page_widget_position = coerceWidgetPositionNumber(result.page_widget_position);
    }
    return result;
  }

  function getPersistedAppVersionName() {
    try {
      if (typeof window.getAppVersionName === "function") {
        return window.getAppVersionName();
      }
      const stored = window.sessionStorage ? window.sessionStorage.getItem("app_version_name") : null;
      const parsed = stored != null && stored !== "" ? parseInt(String(stored), 10) : NaN;
      return Number.isFinite(parsed) ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function enrichEventWithAppVersionName(item) {
    if (!item || typeof item !== "object" || Array.isArray(item)) return item;
    if (typeof item.app_version_name === "number" && Number.isFinite(item.app_version_name)) return item;
    const appVersionName = getPersistedAppVersionName();
    if (appVersionName == null) return item;
    item.app_version_name = appVersionName;
    return item;
  }

  function getInternalEventDedupeKey(internalEventName, eventData) {
    if (
      internalEventName === "internal_pwst_product_items_viewed" &&
      eventData &&
      typeof eventData === "object"
    ) {
      var productId =
        eventData.product_id != null && String(eventData.product_id).trim() !== ""
          ? String(eventData.product_id).trim()
          : eventData.product_title != null && String(eventData.product_title).trim() !== ""
            ? "title:" + String(eventData.product_title).trim()
            : "unknown";
      var widgetPosition =
        eventData.page_widget_position != null ? String(eventData.page_widget_position).trim() : "";
      var productPosition =
        eventData.product_position_inside_widget != null
          ? String(eventData.product_position_inside_widget).trim()
          : "";
      return (
        internalEventName +
        ":" +
        productId +
        ":" +
        widgetPosition +
        ":" +
        productPosition
      );
    }
    return internalEventName;
  }

  function trackMappedInternalEvent(eventData) {
    if (!eventData || typeof eventData !== "object") return;
    if (eventData.__pw_internal_mapped_on_click === true) return;
    if (isAlreadyMappedEvent(eventData)) return;
    var gaEventName = eventData.event;
    var internalEventName = GA_TO_INTERNAL_EVENT_MAP[gaEventName];
    if (!internalEventName) return;

    const now = Date.now();
    window.__PW_INTERNAL_SDK_DEDUPE__ = window.__PW_INTERNAL_SDK_DEDUPE__ || {};
    const isOncePerPageLoadEvent =
      internalEventName === "internal_pwst_product_card_loaded" ||
      internalEventName === "internal_pwst_product_media_loaded";
    const dedupeWindowMs =
      internalEventName === "internal_pwst_login_page_viewed"
        ? 3000
        : internalEventName === "internal_pwst_product_items_viewed"
          ? 0
          : isOncePerPageLoadEvent
            ? Number.POSITIVE_INFINITY
            : 600;
    var dedupeKey = getInternalEventDedupeKey(internalEventName, eventData);
    var lastInternalTs = window.__PW_INTERNAL_SDK_DEDUPE__[dedupeKey];
    if (lastInternalTs && now - lastInternalTs < dedupeWindowMs) {
      return;
    }
    window.__PW_INTERNAL_SDK_DEDUPE__[dedupeKey] = now;

    var payload = {};
    var requiredAttrs =
      window.PWTrackerRequiredAttrs && typeof window.PWTrackerRequiredAttrs.getOrCreate === "function"
        ? window.PWTrackerRequiredAttrs.getOrCreate()
        : {};
    Object.keys(requiredAttrs).forEach(function (key) {
      payload[key] = requiredAttrs[key];
    });
    Object.keys(eventData).forEach(function (key) {
      if (key === "event") return;
      payload[key] = eventData[key];
    });

    payload = normalizeWidgetPositionAttributes(payload);
    enrichEventWithAppVersionName(payload);

    if (eventData.anonymous_id != null && eventData.anonymous_id !== "") {
      payload.anonymous_id = eventData.anonymous_id;
    }
    if (eventData.session_id != null && eventData.session_id !== "") {
      payload.session_id = eventData.session_id;
    }
    if (eventData.event_id != null && eventData.event_id !== "") {
      payload.event_id = eventData.event_id;
    }
    if (eventData.from_app != null) payload.from_app = eventData.from_app;
    if (eventData.is_in_webview != null) payload.is_in_webview = eventData.is_in_webview;
    if (eventData.platform != null && eventData.platform !== "") payload.platform = eventData.platform;

    try {
      payload.user_agent = navigator.userAgent || "";
      payload.referrer = document.referrer || "";
    } catch (e) {
      payload.user_agent = payload.user_agent || "";
      payload.referrer = payload.referrer || "";
    }

    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (utmKey) {
      var utmValue = requiredAttrs[utmKey];
      if (utmValue != null && utmValue !== "") {
        payload[utmKey] = utmValue;
      }
    });

    if (
      window.PWTrackerRequiredAttrs &&
      typeof window.PWTrackerRequiredAttrs.touchSessionForInternalEvent === "function"
    ) {
      payload.session_id =
        eventData.session_id != null && eventData.session_id !== ""
          ? eventData.session_id
          : window.PWTrackerRequiredAttrs.touchSessionForInternalEvent();
    }

    if (payload.shopify_session_id == null || payload.shopify_session_id === "") {
      var shopifySessionId = null;
      if (
        window.PWTrackerRequiredAttrs &&
        typeof window.PWTrackerRequiredAttrs.getShopifySessionId === "function"
      ) {
        shopifySessionId = window.PWTrackerRequiredAttrs.getShopifySessionId();
      }
      if (shopifySessionId) payload.shopify_session_id = shopifySessionId;
    }

    if (!payload.event_id) {
      payload.event_id = generateInternalEventId();
    }

    window.PWLightTrackerJS.logEvent(internalEventName, payload);
    scheduleFastFlush();
    console.log("[PWLightTracker] mapped event tracked", {
      from: gaEventName,
      to: internalEventName,
      event_id: payload.event_id || null,
      product_id: payload.product_id || null,
      region: payload.region || null,
      city: payload.city || null,
      country: payload.country || null,
      anonymous_id: payload.anonymous_id || null,
      session_id: payload.session_id || null,
    });
  }

  function processDataLayerItems(items) {
    if (!items || !items.length) return;
    items.forEach(function (item) {
      if (item && typeof item === "object" && !Array.isArray(item)) {
        trackMappedInternalEvent(item);
      }
    });
  }

  function wrapDataLayerPush(dataLayerRef) {
    if (!dataLayerRef || dataLayerRef.__PWTRACKER_PUSH_WRAPPED__) return;

    const originalPush = typeof dataLayerRef.push === "function" ? dataLayerRef.push : Array.prototype.push;
    dataLayerRef.push = function () {
      const args = Array.prototype.slice.call(arguments).map(function (item) {
        let normalized = normalizeWidgetPositionAttributes(item);
        normalized = enrichGaPwstEventIdentity(normalized);
        return enrichEventWithAppVersionName(normalized);
      });
      processDataLayerItems(args);
      return originalPush.apply(dataLayerRef, args);
    };
    dataLayerRef.__PWTRACKER_PUSH_WRAPPED__ = true;
  }

  function setupDataLayerBridge() {
    window.dataLayer = window.dataLayer || [];
    if (window.__PWTRACKER_GA_BRIDGE_INSTALLED__) return;
    window.__PWTRACKER_GA_BRIDGE_INSTALLED__ = true;

    var activeDataLayerRef = null;

    function ensureBridge() {
      window.dataLayer = window.dataLayer || [];
      if (activeDataLayerRef !== window.dataLayer) {
        activeDataLayerRef = window.dataLayer;
      }
      wrapDataLayerPush(activeDataLayerRef);
      processDataLayerItems(activeDataLayerRef);
    }

    ensureBridge();
    window.setInterval(ensureBridge, 500);
  }

  function waitForGeoReady() {
    return new Promise(function (resolve) {
      if (!window.PWTrackerRequiredAttrs || typeof window.PWTrackerRequiredAttrs.ready !== "function") {
        resolve();
        return;
      }

      var settled = false;
      var timeoutId = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        console.warn("[PWLightTracker] Geo ready wait timed out, continuing bridge setup");
        resolve();
      }, GEO_READY_WAIT_MS);

      window.PWTrackerRequiredAttrs.ready().finally(function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        resolve();
      });
    });
  }

  function initPWTrackerWithRetry(retryCount) {
    if (typeof window.PWLightTrackerJS === "undefined") {
      if (retryCount < 20) {
        setTimeout(function () {
          initPWTrackerWithRetry(retryCount + 1);
        }, 100);
      }
      return;
    }

    var authToken = getAuthTokenFromSessionStorage();
    var resolvedForPayload = getSafeUserId(null);
    var customHeaders = {
      "clientId": "shopify-theme",
      "x-platform": "web",
      "appName": PW_STORE_APP_SLUG,
      "appVersion": PW_STORE_APP_VERSION,
      "x-org-id": "5eb393ee95fab7468a79d189",
      "subOrgId": "SUB-PWST002",
      "x-user-id": resolvedForPayload,
    };
    if (authToken) {
      customHeaders["Authorization"] = "Bearer " + authToken;
    }

    var initOptions = {
      clientId: "5eb393ee95fab7468a79d189",
      appName: PW_STORE_APP_SLUG,
      appVersion: PW_STORE_APP_VERSION,
      authToken: authToken ? "Bearer " + authToken : null,
      subOrgId: "SUB-PWST002",
      enableLogging: true,
      baseUrl: resolveAnalyticsBaseUrl(),
    };
    var trackerBatchName = resolveCustomerNameForTracker();
    initOptions.name = trackerBatchName || "anonymous";
    if (resolvedForPayload !== "anonymous") {
      initOptions.userId = resolvedForPayload;
    }

    window.PWLightTrackerJS.init(initOptions);

    console.log("[PWLightTracker] Init Successfully Theme");

    waitForGeoReady().then(function () {
      setupDataLayerBridge();
    });
  }

  initPWTrackerWithRetry(0);
})();